import React from "react";
import "./App.css";
import "./index.css";
import { Route, Routes } from "react-router-dom";
import Home from "./components/home/Home";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import ScrollToTop from "./components/ScrollTotop/ScrollTotop";
import Services from "./components/services/Services";
import Contact_us from "./components/contact-us/Contact_us";
import Terms_and_condition from "./components/terms_and_condition/Terms_and_condition";
import Privacy_Policy from "./components/privacy_Policy/Privacy_Policy";
import About_Us from "./components/about-us/About_Us";

function App() {
  return (
    <>
      <ScrollToTop/>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About_Us />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact-us" element={<Contact_us />} />
        <Route path="/terms-and-condition" element={<Terms_and_condition />} />
        <Route path="/privacy-policy" element={<Privacy_Policy />} />

      </Routes>
      <Footer />
    </>
  );
}

export default App;
